export const HEADER_ICON_SIZE = 32
/** Refetch throttle timing for when the page is visible */
export const FOREGROUND_REFETCH_THROTTLE_INTERVAL_IN_MS = 2000
/** Refetch throttle timing for when the page is not visible (ie - viewing a different tab) */
export const BACKGROUND_REFETCH_THROTTLE_INTERVAL_IN_MS = 10000
